import React from 'react';
import './Header.css';

/**
 * @Component The header of application
 */
const Header = () => {
  return (
    <header>
      <h1>
        Hand Cricket<br/>
        <small>Relive your childhood game.</small>
      </h1>
    </header>
  );
}

export default Header;